import { AxiosResponse } from "axios";
import {
  CalculatePrice,
  CurrentServiceInterface,
} from "../../reatom/state/currentService/currentService";
import instance from "../instance";

export const getCurrentServiceCard = async (
  id: string
): Promise<CurrentServiceInterface> => {
  try {
    const res: AxiosResponse<CurrentServiceInterface> = await instance.get(
      `/v1/uslugi-freelancera/card/${id}`
    );
    return res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getSummaryCurrentService = async (
  id: string,
  extra: number[]
): Promise<CalculatePrice> => {
  try {
    const params: Record<string, number> = {};

    extra.forEach((value) => {
      params[`extra[${value}]`] = 1;
    });

    const res: AxiosResponse<{ result: CalculatePrice }> = await instance.get(
      `/v1/uslugi-freelancera/card/${id}/calculate`,
      {
        params: params,
        paramsSerializer: (params) => {
          return Object.entries(params)
            .map(([key, value]) => `${key}=${value}`)
            .join("&");
        },
      }
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
